import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faPause } from '@fortawesome/pro-regular-svg-icons';
import { Select, Store } from '@ngxs/store';
import moment from 'moment';
import { interval, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import {
   AcceptOrStartCallAction,
   DisconnectLineA,
   DisconnectLineB,
   StartNewCallAction,
   ToggleHoldLineB,
} from 'src/app/store/samwin/client-phone/client-phone.actions';
import { ClientPhoneState } from 'src/app/store/samwin/client-phone/client-phone.state';
import { DialTarget, NextDialTargetState } from 'src/app/store/samwin/next-dial-target/next-dial-target.state';
import { SamwinLinesStateSelector } from 'src/app/store/samwin/samwin-lines/samwin-lines.selector';
import { SamwinUserStatusState } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.state';
import { TransferCallAction } from 'src/app/store/samwin/transfer/transfer.actions';
import { TransferState } from 'src/app/store/samwin/transfer/transfer.state';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { SamwinLineStatusRemoteDto } from 'src/generated/signalR/samwin-line-status-remote-dto';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';

@Component({
   selector: 'samweb-stage-line-b',
   templateUrl: './stage-line-b.component.html',
   styleUrls: ['./stage-line.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StageLineBComponent implements OnInit {
   constructor(private store: Store) {}

   @Select(SamwinLinesStateSelector.getCurrentCall)
   public callInfo$: Observable<SamwinCallInfoRemoteDto>;

   @Select(SamwinLinesStateSelector.isCallInProgress)
   public isCallInProgress$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.canDisconnectLineA)
   public canDisconnectLineA$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.canDisconnectLineB)
   public canDisconnectLineB$: Observable<boolean>;

   @Select(ClientPhoneState.canPhoneMakeCall)
   public canPhoneMakeCall$: Observable<boolean>;

   @Select(ClientPhoneState.isCallRingingAndAcceptable)
   public isCallRingingAndAcceptable$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.isPhoneRinging)
   public isPhoneRinging$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.isLineBOnHold)
   public isLineBOnHold$: Observable<boolean>;

   @Select(ClientPhoneState.isLineBIdle)
   public isLineBIdle$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.canToggleHoldLineB)
   public canToggleHoldLineB$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.getDestinationLineStateModel)
   public currentDestinationLineStateModel$: Observable<SamwinLineStatusRemoteDto>;

   @Select(SamwinUserStatusState.getNextAutoStatusChangeTime)
   public currentUserStatusDuration$: Observable<moment.Moment>;

   @Select(SamwinUserStatusState.currentStatusInfo)
   public currentUserStatusInfo$: Observable<UserStatusInfoRemoteDto>;

   @Select(TransferState.canTransfer)
   public canTransfer$: Observable<boolean>;

   public nextDialTarget$: Observable<DialTarget>;

   public now$ = interval(500).pipe(map(() => moment().subtract(250, 'milliseconds')));

   public brickInstanceId: string;

   public answerIcon: IconDefinition = WellKnownIconsEnum.CALLING_ANSWER.icon;
   public dialArrowIcon: IconDefinition = WellKnownIconsEnum.CALLING_DIAL_ARROW.icon;
   public hangUpIcon: IconDefinition = WellKnownIconsEnum.CALLING_HANGUP.icon;
   public transferIcon: IconDefinition = WellKnownIconsEnum.CALLING_TRANSFER.icon;
   public holdIcon: IconDefinition = faPause;

   ngOnInit() {
      this.nextDialTarget$ = this.store.select(NextDialTargetState.nextDialTarget).pipe(debounceTime(300));
   }

   disconnectLineA() {
      this.store.dispatch(new DisconnectLineA());
   }

   disconnectLineB() {
      this.store.dispatch(new DisconnectLineB());
   }

   acceptOrStartCall() {
      this.store.dispatch(new AcceptOrStartCallAction());
   }

   callTarget() {
      this.store.dispatch(new StartNewCallAction(this.store.selectSnapshot(NextDialTargetState.nextDialTarget)));
   }

   transferCall() {
      this.store.dispatch(new TransferCallAction());
   }

   holdLine() {
      this.store.dispatch(new ToggleHoldLineB());
   }
}
